import ModuleContainer from "@/components/Map/ModuleContainer.vue";

export default {
  components: {
    ModuleContainer
  },

  props: {
    position: {
      type: String,
      default: "bottomright",
      validator(value) {
        return (
          ["topleft", "topright", "bottomleft", "bottomright"].indexOf(
            value
          ) !== -1
        );
      }
    }
  },

  data() {
    return {
      loaded: false,
      map: null,
      controls: []
    };
  },

  inject: ["getMap"],

  created() {
    this.$once("module-loaded", () => {
      this.loaded = true;
    });

    this.$on("module-failed", () => {
      this.loaded = false;
    });

    this.getMap(async map => {
      this.map = map;

      // Revoke event
      if (this.onInit instanceof Function) {
        const command = this.onInit();

        if (command instanceof Promise) {
          try {
            await command;
          } catch (error) {
            console.error(error);
            this.$emit("module-failed");
            return;
          }
        }
      }

      this.$emit("module-loaded");
    });
  },

  beforeDestroy() {
    if (!this.map) return;

    if (this.onDestroy instanceof Function) {
      this.onDestroy();
    }
    this.removeControl();
    this.map = null;
  },

  methods: {
    addControl(controlInstance, options = {}) {
      controlInstance.options.position = options.position || this.position;

      this.controls.push(controlInstance);

      this.map.addControl(controlInstance);
    },

    removeControl() {
      if (this.controls.length === 0 || !this.map) return;

      try {
        this.controls.forEach(control => {
          this.map.removeControl(control);
        });
      } catch (error) {
        console.error(error);
      }

      this.control = [];
    },

    getControls() {
      if (this.loaded) {
        return Promise.resolve(this.controls);
      } else {
        return new Promise((resolve, reject) => {
          this.$once("module-loaded", () => {
            resolve(this.controls);
          });

          this.$once("module-failed", reject);
        });
      }
    }
  }
};
